<template>
  <div>
    <v-dialog width="450" v-model="endDNDNoteModal" persistent>
      <v-card>
        <v-row no-gutters>
          <v-col cols="12" class="modal-header py-5">
            <v-row no-gutters>
              <v-spacer></v-spacer>
              <span class="modal-title-text mr-2">توضیحات پایان DND</span>
              <v-spacer></v-spacer>
              <v-icon class="ml-3" @click="cancleDNDNoteModal()">mdi-close</v-icon>
            </v-row>
          </v-col>
        </v-row>
        <v-card-text>
          <v-row no-gutters class="mt-4">
            <v-col cols="12" class="mt-1 mr-1">
              <v-textarea dense rows="5" outlined label="علت" clearable class="sugest-input"
                clear-icon="mdi-close-circle-outline" prepend-inner-icon="mdi-note mdi-18px"
                v-model="endDNDNote"></v-textarea>
            </v-col>
          </v-row>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-row no-gutters>
            <v-spacer></v-spacer>
            <v-btn rounded color="darkColor" dark @click="setFinishDND()" class="normal-letter-spacing px-10 ml-4">
              ثبت
            </v-btn>
            <v-btn rounded color="darkColor" outlined @click="cancleDNDNoteModal()" class="normal-letter-spacing px-10">
              انصراف
            </v-btn>
          </v-row>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog persistent width="600" v-model="changeRoleModalFlag">
      <v-card>
        <v-row no-gutters>
          <v-col cols="12" class="modal-header py-5">
            <v-row no-gutters>
              <v-spacer></v-spacer>
              <v-icon color="darkColor">mdi-account-switch</v-icon>
              <span class="modal-title-text2 mr-2">تغییر نقش</span>
              <v-spacer></v-spacer>
              <v-icon color="darkColor" @click="cancleChangeRole()" class="ml-2">mdi-close</v-icon>
            </v-row>
          </v-col>
        </v-row>
        <v-card-text class="mt-12">
          <v-row>
            <v-col cols="12" v-if="changeRolePageType == 'extension'">
              <v-row>
                <v-spacer></v-spacer>
                <v-col cols="11" class="mr-4">
                  <v-row>
                    <v-col cols="4" v-for="item in allExtensionsForOther" :key="item.id">
                      <v-btn block large color="darkColor" dark elevation="0" rounded @click="confirmedExtension(item)">
                        {{ item.sipExtension }}
                      </v-btn>
                    </v-col>
                  </v-row>
                </v-col>
                <v-spacer></v-spacer>
              </v-row>
            </v-col>
            <v-col cols="12" v-if="changeRolePageType == 'zone'">
              <v-row>
                <v-spacer></v-spacer>
                <v-col cols="11" class="mr-4">
                  <v-row>
                    <v-col cols="4" v-for="item in allZones" :key="item.id">
                      <v-btn block large color="darkColor" dark elevation="0" rounded @click="confirmedZone(item)">
                        {{ item.title }}
                      </v-btn>
                    </v-col>
                  </v-row>
                </v-col>
                <v-spacer></v-spacer>
              </v-row>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-dialog persistent width="90%" v-model="deploymentModal">
      <deployment-component v-if="deploymentModal"></deployment-component>
    </v-dialog>
    <!-- ///// -->
    <v-dialog persistent v-model="showDialogNewform" content-class="bottom-dialog"
      transition="dialog-bottom-transition">
      <div>
        <div class="NewtabsCall">
          <div v-for="(item, index1) in newFormList" :key="index1" class="tab-wrapper">
            <span v-if="newTabForm === item?.uniqueId" class="newTabFormAnim tab-new-label">
              جدید
            </span>

            <div class="tab-item" :class="{ selectedTab: index1 === selectFormList }" @click="
              selectFormList = index1;
            if (newTabForm === item?.uniqueId) newTabForm = null;
            ">
              <span class="nowrap-text">شماره تماس : {{ item?.callerId || '--' }}</span>
            </div>
          </div>
        </div>

        <div class="newCallContent">
          <new-call-component v-for="(item, index) in newFormList"
            :classCustom="index !== selectFormList ? 'moveOutsideRight' : ''" :key="item.uniqueId"
            :uniqueId="item.uniqueId" :callerId="item.callerId" :destination="item.destination" :type="item.newFormType"
            :selectItemFormList="index === selectFormList"></new-call-component>
        </div>
      </div>
    </v-dialog>
    <!--audio ***********************************************-->
    <!-- <v-dialog v-model="playerHome" width="400px" style="overflow-x: hidden" :key="recordFileHome"> -->
    <div v-if="playerHome" v-show="!showDialogNewform" :key="recordFileHome" class="audioPlayerHome">
      <v-card width="100%">
        <div class="audioPlayerHomeContent">
          <audio controls oncontextmenu="return false;" controlsList="nodownload" cors-anonym="true" autoplay
            :src="recordFileHome" ref="audioFileHome"></audio>
          <v-btn color="primary" class="no-letter-space" @click="stopMusicHome()">بستن</v-btn>
        </div>
      </v-card>
    </div>
    <!-- </v-dialog> -->
    <!-- ///// -->
    <v-dialog content-class="new-call-dialog border50" v-model="ringingModal" width="500" persistent>
      <v-card class="rounded-lg">
        <div class="new-call-header">
          <v-icon color="white" class="my-3">mdi-phone mdi-flip-h</v-icon>
          <span class="modal-title-text mr-2 mt-3">تماس جدید</span>
        </div>
        <v-row no-gutters>
          <v-spacer></v-spacer>
          <v-col cols="10" class="mt-10">
            <v-row>
              <v-spacer></v-spacer>
              <span class="new-call-modal-number new-call-modal-number-text">
                {{ callInformationModel?.callerId }}
              </span>
              <div class="forth-div-call">
                <div class="thrid-div-call">
                  <div class="second-div-call">
                    <div class="first-div-call">
                      <v-icon color="white" class="new-call-calling-icon-position">
                        mdi-phone-in-talk mdi-18px
                      </v-icon>
                    </div>
                  </div>
                </div>
              </div>
              <v-spacer></v-spacer>
              <v-icon class="ml-3" @click="closeCallModal">mdi-close</v-icon>
            </v-row>
          </v-col>
          <v-spacer></v-spacer>
        </v-row>
        <v-card-text class="new-call-dialog-card-content">
          <v-row>
            <v-spacer></v-spacer>
            <v-col cols="10" class="mt-6">
              <v-row>
                <span class="recent-text">سابقه</span>
                <v-divider class="mt-3 mr-3"></v-divider>
              </v-row>
            </v-col>
            <v-spacer></v-spacer>
          </v-row>
          <v-row no-gutters class="mt-4">
            <v-col cols="4" v-for="item in allRecentCalls" :key="item?.id"
              class="flex flex-col gap-1 items-center recent-call-new-call-dialog-container px-2 pb-4">
              <div class="recent-call-new-call-dialog-card">
                <div class="flex flex-col gap-1 items-center recent-call-new-call-dialog-card-body pa-2">
                  <div class="recent-result">{{ item.result }}</div>
                  <div class="divider mx-1"></div>
                  <div class="recent-date">{{ item.date }}</div>
                  <div class="recent-date">{{ item.time }}</div>
                </div>
              </div>
              <div>
                {{ item?.operator }}
              </div>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-app-bar v-if="!menuHidden" app color="background" elevation="0" height="48px">
      <div class="appbar-wrapper">
        <div class="appbar-left">
          <img :src="logo" contain width="30px" height="30px" class="logo" />
          <span class="time">{{ time }}</span>
        </div>

        <div class="appbar-center">
          <span class="title-main">آسایار</span>
          <span class="title-sub">( سامانه اتوماسیون اورژانس پیش بیمارستانی )</span>
        </div>

        <div class="appbar-right">
          <v-chip v-if="showExtension" color="white" text-color="darkColor" small class="extension">
            <v-icon left small>mdi-face-agent</v-icon>
            {{ userExtension }}
          </v-chip>

          <v-btn v-if="is800Section" fab dense dark x-small color="darkColor" @click="setNotificationBarOpen(true)">
            <v-icon>mdi-bell</v-icon>
          </v-btn>
        </div>
      </div>
    </v-app-bar>
    <v-navigation-drawer v-model="drawer" :mini-variant.sync="mini" ref="mainDrawer" :permanent="!menuHidden"
      :temporary="menuHidden" right class="mr-2 drawer-design " absolute color="lightColor">
      <v-list-item class="px-2 py-1 menu-header" dark>
        <v-list-item-title class="text--white menu-username-content mr-2" v-if="!mini">
          {{ moduleName }}
        </v-list-item-title>
        <v-list-item-avatar>
          <v-icon v-if="mini" color="white" @click.stop="toggleMenu()">mdi-backburger</v-icon>
          <v-icon v-else color="white" @click.stop="toggleMenu()">mdi-backburger mdi-flip-h</v-icon>
        </v-list-item-avatar>
      </v-list-item>
      <v-list dense class="myList">
        <v-list-item v-for="item in menuItems" :key="item.title" @click="() => onMenuItemClick(item.title, item.module)"
          link>
          <v-list-item-icon>
            <v-icon dark>{{ item.icon }}</v-icon>
          </v-list-item-icon>
          <!--admin-->
          <v-list-item-content v-if="item.title == 'کاربران'">
            <v-list-group>
              <template v-slot:activator>
                <v-list-item-content>
                  <v-list-item-title class="" style="color: white">
                    {{ item.title }}
                  </v-list-item-title>
                </v-list-item-content>
              </template>
              <v-list-item v-for="sitem in userItems" :key="sitem.title" @click="sendToUrlUser(sitem.title)">
                <v-list-item-content>
                  <v-list-item-title class="mr-3" style="color: white !important">
                    {{ sitem.title }}
                  </v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </v-list-group>
          </v-list-item-content>
          <v-list-item-content v-if="item.title == 'تقسیمات کشوری'">
            <v-list-group>
              <template v-slot:activator>
                <v-list-item-content>
                  <v-list-item-title class="" style="color: white">
                    {{ item.title }}
                  </v-list-item-title>
                </v-list-item-content>
              </template>
              <v-list-item v-for="sitem in countryItems" :key="sitem.title" @click="sendToUrlCountry(sitem.title)">
                <v-list-item-content>
                  <v-list-item-title class="mr-3" style="color: white !important">
                    {{ sitem.title }}
                  </v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </v-list-group>
          </v-list-item-content>
          <v-list-item-content v-if="item.title == 'اطلاعات پایه'">
            <v-list-group>
              <template v-slot:activator>
                <v-list-item-content>
                  <v-list-item-title class="" style="color: white">
                    {{ item.title }}
                  </v-list-item-title>
                </v-list-item-content>
              </template>
              <v-list-item v-for="sitem in baseInformationItems" :key="sitem.title"
                @click="sendToUrlBaseInformation(sitem.title)">
                <v-list-item-content>
                  <v-list-item-title class="mr-3" style="color: white !important">
                    {{ sitem.title }}
                  </v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </v-list-group>
          </v-list-item-content>
          <v-list-item-content v-if="item.title == 'اطلاعات سامانه'">
            <v-list-group>
              <template v-slot:activator>
                <v-list-item-content>
                  <v-list-item-title class="" style="color: white">
                    {{ item.title }}
                  </v-list-item-title>
                </v-list-item-content>
              </template>
              <v-list-item v-for="sitem in appInformationItems" :key="sitem.title"
                @click="sendToUrlAppInformation(sitem.title)">
                <v-list-item-content>
                  <v-list-item-title class="mr-3" style="color: white !important">
                    {{ sitem.title }}
                  </v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </v-list-group>
          </v-list-item-content>
          <v-list-item-content v-if="item.title == 'مدیریت داروها'">
            <v-list-group>
              <template v-slot:activator>
                <v-list-item-content>
                  <v-list-item-title class="" style="color: white">
                    {{ item.title }}
                  </v-list-item-title>
                </v-list-item-content>
              </template>
              <v-list-item v-for="sitem in drugItems" :key="sitem.title" @click="sendToUrlDrug(sitem.title)">
                <v-list-item-content>
                  <v-list-item-title class="mr-3" style="color: white !important">
                    {{ sitem.title }}
                  </v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </v-list-group>
          </v-list-item-content>
          <v-list-item-content v-if="item.title == 'داشبورد' && item.type == '2'"
            @click="goToItems(item.title, item.module)">
            <v-list-item-title dark class="text--white menu-items mr-3">
              {{ item.title }}
            </v-list-item-title>
          </v-list-item-content>
          <v-list-item-content v-if="item.title == 'ماموریت ها' && item.type == '2'">
            <v-list-item-title dark class="text--white menu-items mr-3" @click="goToItems(item.title, item.module)">
              {{ item.title }}
            </v-list-item-title>
          </v-list-item-content>
          <!-- //dashboards -->
          <v-list-item-content v-if="(item.title == 'داشبورد 800' ||
            item.title == 'داشبورد پذیرش' || item.title == 'داشبورد 115') && item.type == '15'"
            @click="goToItems(item.title, item.module)">
            <v-list-item-title dark class="text--white menu-items mr-3">
              {{ item.title }}
            </v-list-item-title>
          </v-list-item-content>
          <!-- <v-list-item-content v-if="item.title == 'داشبورد 115' && item.type == '15'">
            <v-list-group>
              <template v-slot:activator>
                <v-list-item-content>
                  <v-list-item-title class="" style="color: white">
                    {{ item.title }}
                  </v-list-item-title>
                </v-list-item-content>
              </template>
              <v-list-item v-for="sitem in item.subMenu" :key="sitem.title"
                @click="goToItems(sitem.title, item.module)">
                <v-list-item-content>
                  <v-list-item-title class="mr-3" style="color: white !important">
                    {{ sitem.title }}
                  </v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </v-list-group>
          </v-list-item-content> -->
          <!-- //NEW 800 -->
          <v-list-item-content v-if="item.title == 'ماموریت های جدید' && item.type == '2'">
            <v-list-item-title dark class="text--white menu-items mr-3" @click="goToItems(item.title, item.module)">
              {{ item.title }}
            </v-list-item-title>
          </v-list-item-content>
          <v-list-item-content v-if="item.title == 'نقشه' && item.type == '2'">
            <v-list-item-title dark class="text--white menu-items mr-3" @click="goToItems(item.title, item.module)">
              {{ item.title }}
            </v-list-item-title>
          </v-list-item-content>
          <v-list-item-content v-if="item.title == 'کد ها' && item.type == '2'">
            <v-list-item-title dark class="text--white menu-items mr-3" @click="goToItems(item.title, item.module)">
              {{ item.title }}
            </v-list-item-title>
          </v-list-item-content>
          <v-list-item-content v-if="item.title == 'کد های 10-7' && item.type == '2'">
            <v-list-item-title dark class="text--white menu-items mr-3" @click="goToItems(item.title, item.module)">
              {{ item.title }}
            </v-list-item-title>
          </v-list-item-content>
          <v-list-item-content v-if="item.title == 'لیست ترمینه' && item.type == '2'">
            <v-list-item-title dark class="text--white menu-items mr-3" @click="goToItems(item.title, item.module)">
              {{ item.title }}
            </v-list-item-title>
          </v-list-item-content>
          <v-list-item-content v-if="item.title == 'بیمارستان ها' && item.type == '2'">
            <v-list-item-title dark class="text--white menu-items mr-3" @click="goToItems(item.title, item.module)">
              {{ item.title }}
            </v-list-item-title>
          </v-list-item-content>
          <v-list-item-content v-if="item.title == 'ماموریت استقرار' && item.type == '2'">
            <v-list-item-title dark class="text--white menu-items mr-3" @click="goToItems(item.title, item.module)">
              {{ item.title }}
            </v-list-item-title>
          </v-list-item-content>
          <v-list-item-content v-if="item.title == 'ماموریت جدید' && item.type == '2'">
            <v-list-item-title dark class="text--white menu-items mr-3" @click="goToItems(item.title, item.module)">
              {{ item.title }}
            </v-list-item-title>
          </v-list-item-content>
          <v-list-item-content v-if="item.title === 'اعلانات' && item.type == '2'">
            <v-list-item-title dark class="text--white menu-items mr-3" @click="goToItems(item.title, item.module)">
              {{ item.title }}
            </v-list-item-title>
          </v-list-item-content>
          <v-list-item-content v-if="item.title == 'گزارشات' && item.type == '2'">
            <v-list-group>
              <template v-slot:activator>
                <v-list-item-content>
                  <v-list-item-title class="" style="color: white">
                    {{ item.title }}
                  </v-list-item-title>
                </v-list-item-content>
              </template>
              <v-list-item v-for="sitem in reportItems" :key="sitem.title"
                @click="sendToUrlReport(sitem.title, item.module)">
                <v-list-item-content>
                  <v-list-item-title class="mr-3" style="color: white !important">
                    {{ sitem.title }}
                  </v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </v-list-group>
          </v-list-item-content>
          <v-list-item-content v-if="item.title == 'گزارشات' && item.type == '1'">
            <v-list-item-title dark class="text--white menu-items mr-3" @click="goToItems(item.title, item.module)">
              {{ item.title }}
            </v-list-item-title>
          </v-list-item-content>
          <v-list-item-content v-if="item.title == 'تنظیمات' && item.module == '800'">
            <v-list-item-title dark class="text--white menu-items mr-3" @click="goToItems(item.title, item.module)">
              {{ item.title }}
            </v-list-item-title>
          </v-list-item-content>
          <v-list-item-content v-else-if="item.title == 'تنظیمات'">
            <v-list-group>
              <template v-slot:activator>
                <v-list-item-content>
                  <v-list-item-title class="" style="color: white">
                    {{ item.title }}
                  </v-list-item-title>
                </v-list-item-content>
              </template>
              <v-list-item v-for="sitem in settingItems" :key="sitem.title" @click="sendToUrlSetting(sitem.title)">
                <v-list-item-content>
                  <v-list-item-title class="mr-3" style="color: white !important">
                    {{ sitem.title }}
                  </v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </v-list-group>
          </v-list-item-content>
        </v-list-item>
      </v-list>
      <template v-slot:append>
        <div class="mr-1 mb-1" v-show="mini">
          <v-col cols="12" class="mr-n2" v-show="allowUsingDND">
            <v-btn color="darkColor" dark x-small rounded @click="enableUserDNDsnFunction('home')"
              v-show="isMainDND == false">
              DND
            </v-btn>
            <span v-show="isMainDND == true">{{ dndTime }}</span>
            <v-btn color="white" v-if="isMainDND" light x-small @click="showDNDNoteModal('home')" rounded
              class="end-dnd-btn">
              DND
            </v-btn>
          </v-col>
          <v-col cols="12">
            <hr class="menu-bottom-divider" />
          </v-col>
          <v-col cols="12" class="mt-n3">
            <v-img :src="'data:image/png;base64,' + user.img" height="4vh" width="6vh" v-if="user && user.img"
              class="user-menu-img"></v-img>
            <v-icon v-else color="white" class="user-no-img">mdi-account</v-icon>
          </v-col>
          <v-col cols="12" class="mt-n3">
            <v-icon color="white" class="expand-menu-icon" @click="logOut()">mdi-logout</v-icon>
          </v-col>
          <v-col cols="12" class="mb-n2 mt-n3">
            <span class="version-text">{{ versionNumber }}</span>
          </v-col>
        </div>
        <v-row v-show="!mini">
          <v-col cols="12" v-show="allowUsingDND">
            <v-row v-show="isMainDND == false">
              <v-spacer></v-spacer>
              <v-col cols="11">
                <v-btn color="darkColor" dark small rounded class="px-2" block @click="enableUserDNDsnFunction('home')">
                  DND
                </v-btn>
              </v-col>
              <v-spacer></v-spacer>
            </v-row>
            <v-row v-show="isMainDND == true">
              <v-spacer></v-spacer>
              <v-col cols="11">
                <v-card>
                  <div class="dndStyleMenu">
                    <div class="itemTime">
                      <v-icon color="darkColor">mdi-clock-outline mdi-18px</v-icon>
                      <span>زمان شروع</span>
                      <div class="divid"></div>
                      <span class="txt">{{ startDNDTime }}</span>
                    </div>
                    <div class="itemTime">
                      <v-icon color="darkColor">mdi-timer-sand mdi-18px</v-icon>
                      <span>مدت زمان</span>
                      <div class="divid"></div>
                      <span class="txt">{{ dndTime }}</span>
                    </div>
                    <div class="btn">
                      <v-btn color="darkColor" dark small block @click="showDNDNoteModal('home')" rounded>
                        پایان DND
                      </v-btn>
                    </div>
                  </div>
                </v-card>
              </v-col>
              <v-spacer></v-spacer>
            </v-row>
          </v-col>
          <v-col cols="12">
            <hr class="menu-bottom-divider-open" />
          </v-col>
          <v-col cols="12" class="mt-n3">
            <v-row>
              <v-col cols="4">
                <v-img :src="'data:image/png;base64,' + user.img" height="5vh" width="5vh" @click="goToProfile()"
                  v-if="user && user.img" class="user-menu-img mr-6"></v-img>
                <v-icon v-else color="white" class="user-no-img mr-8" @click="goToProfile()">
                  mdi-account
                </v-icon>
              </v-col>
              <v-col cols="6" class="mr-n3">
                <v-row>
                  <v-col cols="12">
                    <span class="menu-user-fullname" @click="goToProfile()">
                      {{ userFullName }}
                    </span>
                  </v-col>
                  <v-col cols="12" class="mt-n6">
                    <span class="menu-user-role" @click="goToProfile()">{{ userRoleTitle }}</span>
                  </v-col>
                </v-row>
              </v-col>
              <v-col cols="1" class="mr-n8">
                <v-menu class="change-role-modal-menu" v-model="changeRoleModal" nudge-left="58" nudge-bottom="0"
                  rounded="l-xl" :nudge-width="250">
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn class="mx-2" fab dark v-bind="attrs" v-on="on" x-small color="white" elevation="0">
                      <v-icon dark color="lightColor">mdi-sync mdi-18px</v-icon>
                    </v-btn>
                  </template>

                  <v-card elevation="0" class="change-role-modal" height="93vh">
                    <v-card-text>
                      <v-row class="mt-1">
                        <span class="change-role-modal-title mr-2">تغییر نقش</span>
                        <v-divider class="mt-3 mr-3 ml-2" color="white"></v-divider>
                      </v-row>
                      <v-row>
                        <v-col cols="12">
                          <v-card v-for="item in userRoles" :key="item.id" elevation="0"
                            @click="changeUserModule(item.englishTitle, item.id)"
                            class="change-role-modal-items-card mt-2">
                            <v-card-text class="py-7">
                              <v-row>
                                <v-icon color="white">mdi-account</v-icon>
                                <span class="mr-2 mt-1 change-role-modal-items-card-text">
                                  {{ item.persianTitle }}
                                </span>
                                <v-spacer></v-spacer>
                                <v-icon color="white" v-if="currentRoleId == item.id">
                                  mdi-circle
                                </v-icon>
                                <v-icon color="white" v-else>mdi-circle-outline</v-icon>
                              </v-row>
                            </v-card-text>
                          </v-card>
                        </v-col>
                      </v-row>
                    </v-card-text>
                  </v-card>
                </v-menu>
              </v-col>
              <v-spacer></v-spacer>
            </v-row>
          </v-col>
          <v-col cols="12" class="mt-n6">
            <v-icon color="white" class="expand-menu-icon mr-7" @click="logOut()">
              mdi-logout
            </v-icon>
          </v-col>
          <v-col cols="12" class="mt-n3">
            <span class="version-text-open-menu mr-8">{{ versionNumber }}</span>
          </v-col>
        </v-row>
      </template>
    </v-navigation-drawer>
    <v-navigation-drawer v-model="isNotificationBarOpen" width="362px" absolute temporary class="notification-bar">
      <v-row no-gutters class="d-flex flex-col">
        <v-row no-gutters class="notification-bar-header justify-center mb-4">
          <v-col class="flex items-center justify-start">
            <div class="notification-bar-header-title">اعلانات</div>
          </v-col>
          <v-col class="flex items-center justify-end">
            <v-btn dark color="darkColor" icon v-on="on" v-bind="attrs">
              <v-icon>mdi-message-fast mdi-20px</v-icon>
            </v-btn>
          </v-col>
          <v-col cols="12">
            <div class="notification-bar-header-seperator"></div>
          </v-col>
        </v-row>
        <v-row no-gutters style="height: 80vh" class="px-4">
          <v-virtual-scroll :bench="0" :items="userNotificationsItems" max-height="100%" item-height="80px">
            <template v-slot:default="{ item }">
              <user-notification-box :key="item" v-bind="item"></user-notification-box>
            </template>
          </v-virtual-scroll>
        </v-row>
      </v-row>
    </v-navigation-drawer>
    <v-main class="site-main-content-position">
      <div>
        <v-container fluid>
          <router-view />
        </v-container>
      </div>
    </v-main>
    <alert-component ref="snackRef" :snakTimeOut="snakTimeOut" :snackColor="snackColor" :snackText="snackText"
      :snakIcon="snakIcon"></alert-component>
  </div>
</template>
<script>
import CryptoJS from 'crypto-js';
import Vue from 'vue';
import AlertComponent from '../components/AlertComponent.vue';
import NewCallComponent from '../components/115/NewCallComponent.vue';
import DeploymentComponent from '../components/115/DeploymentComponent.vue';
import MainMenuHelper from '../Helpers/MainMenuHelper.js';
import ThemeHelper from '@/Helpers/ThemeHelper';
import UserNotificationBox from '../components/800/userNotificationBox.vue';
import HomeHelper from '@/Helpers/HomeHelper';
import SharedHelper from '@/Helpers/Shared.js';
import HomeMixin from '../Mixins/Home.js';
import CallMixin from '../Mixins/Call/CallMixin.js';
import snackBar from '@/Mixins/snackBar.js';
import ZoneMixin from '@/Mixins/BaseInformation/ZoneMixin.js';
import ExtensionMixin from '@/Mixins/BaseInformation/ExtensionMixin.js';
import UserMixin from '@/Mixins/BaseInformation/UserMixin.js';
import UserDNDMixin from '@/Mixins/BaseInformation/UserDNDMixin.js';
import UserNotificationMixin from '../Mixins/800/userNotification.mixin.js';
export default {
  inject: ['appThemeChange'],
  components: { AlertComponent, NewCallComponent, DeploymentComponent, UserNotificationBox },
  mixins: [
    MainMenuHelper,
    HomeMixin,
    ThemeHelper,
    HomeHelper,
    CallMixin,
    snackBar,
    ZoneMixin,
    ExtensionMixin,
    UserMixin,
    SharedHelper,
    UserDNDMixin,
    UserNotificationBox,
    UserNotificationMixin,
  ],
  data() {
    return {
      logo: require('@/assets/images/SetareHayat.png'),
      isMainDND: false,
      endDNDNoteModal: false,
      endDNDNote: '',
      endDNDType: '',
      uniqueId: null,
      versionNumber: '5.16.8',
      activeToastIds: {},
      menuHidden: false,
      miniBeforeHide: false,
    };
  },
  created() {
    setInterval(() => {
      this.getNow();
    }, 1000);
    this.$root.$refs.Home = this;
    this.getUserFunctionForMainPage();
    let bytes = CryptoJS.AES.decrypt(localStorage.getItem('dash'), 'f9rr8Y2D96Klh87N');
    let moduleId = '';
    if (bytes.sigBytes != 0) {
      moduleId = JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
    } else {
      moduleId = '';
    }
    if (moduleId === 3) {
      this.getLocalStream();
      this.showExtension = true;
      this.allowUsingDND = true;
      this.$mainSignalr.bus.$on('Ringing', this.fRinging);
      this.$mainSignalr.bus.$on('Up', this.fUp);
      this.$mainSignalr.bus.$on('HangUp', this.fHangUp);
    } else if (moduleId === 2) {
      this.getLocalStream();
      this.showExtension = true;
      this.$mainSignalr.bus.$on('Up', this.onAgentContactInDispatchModule);
      this.$mainSignalr.bus.$on('HangUp', this.onDispatchHangup);
    } else if (moduleId === 6) {
      this.getLocalStream();
      this.showExtension = true;
    } else if (moduleId === 7) {
      this.getLocalStream();
      this.showExtension = true;
    } else if (moduleId === 8) {
      this.$mainSignalr.bus.$on('Up', this.onAgentContactInDoctorModule);
      this.$mainSignalr.bus.$on('HangUp', this.onDoctorHangup);
      this.getLocalStream();
      this.showExtension = true;
    } else if (moduleId === 9) {
      this.getLocalStream();
    } else if (moduleId === 12) {
      this.getLocalStream();
    } else if (moduleId === 14) {
      this.getLocalStream();
      // this.showExtension = true;
    }
  },
  beforeDestroy() {
    this.dndTime = '';
    clearInterval(this.dndTimeInterval);
    this.dndTimeInterval = null;
  },
  mounted() {
    Vue.prototype.$mobileSignalr.start();
    Vue.prototype.$mainSignalr.start();
  },

  methods: {
    // حالت «منوی مخفی» (برای داشبورد تمام‌صفحه): منو بسته است و با openMenu باز می‌شود
    setMenuHidden(hidden) {
      if (hidden === this.menuHidden) return;
      if (hidden) this.miniBeforeHide = this.mini;
      this.menuHidden = hidden;
      this.$nextTick(() => {
        const drawer = this.$refs.mainDrawer;
        if (hidden) {
          this.drawer = false;
          if (drawer) drawer.isActive = false;
        } else {
          this.mini = !!this.miniBeforeHide;
          this.drawer = true;
          if (drawer) drawer.isActive = true;
        }
      });
    },
    openMenu() {
      this.mini = false;
      if (!this.menuHidden) return;
      this.drawer = true;
      const drawer = this.$refs.mainDrawer;
      if (drawer) drawer.isActive = true;
    },
    // دکمه‌ی داخل منو: در حالت عادی mini/باز، در حالت مخفی کاملاً می‌بندد
    toggleMenu() {
      if (!this.menuHidden) {
        this.mini = !this.mini;
        return;
      }
      this.drawer = false;
      const drawer = this.$refs.mainDrawer;
      if (drawer) drawer.isActive = false;
    },
    checkDND: function (data) {
      if (data.currentExtension) {
        this.isMainDND = data.currentExtension.isDND;
        if (this.isMainDND) {
          let now = new Date();
          let diffTime = now.getTime() - new Date(data.currentExtension.startDateDND).getTime();
          this.dndTime = this.msToTime(diffTime);
          this.startDNDTime = Vue.moment(data.currentExtension.startDateDND).format('HH:mm');
          this.dndTimeInterval = setInterval(() => {
            diffTime = diffTime + 1000;
            this.dndTime = this.msToTime(diffTime);
          }, 1000);
        }
      }
    },
    startDNDHome: function (type) {
      if (type == 'newCall') {
        let data = this.$store.state.userModule.user;
        if (data.currentExtension) {
          this.isMainDND = data.currentExtension.isDND;
          if (this.isMainDND) {
            let now = new Date();
            let diffTime = now.getTime() - new Date(data.currentExtension.startDateDND).getTime();
            this.startDNDTime = Vue.moment(data.currentExtension.startDateDND).format('HH:mm');
            this.dndTime = this.msToTime(diffTime);
            this.dndTimeInterval = setInterval(() => {
              diffTime = diffTime + 1000;
              this.dndTime = this.msToTime(diffTime);
            }, 1000);
          }
        }
      } else {
        this.$store.dispatch('getUserCurrent').then(() => {
          if (this.$store.state.userModule.successFlag) {
            let data = this.$store.state.userModule.user;
            if (data.currentExtension) {
              this.isMainDND = data.currentExtension.isDND;
              if (this.isMainDND) {
                let now = new Date();
                let diffTime =
                  now.getTime() - new Date(data.currentExtension.startDateDND).getTime();
                this.dndTime = this.msToTime(diffTime);
                this.startDNDTime = Vue.moment(data.currentExtension.startDateDND).format('HH:mm');
                this.dndTimeInterval = setInterval(() => {
                  diffTime = diffTime + 1000;
                  this.dndTime = this.msToTime(diffTime);
                }, 1000);
              }
            }
          }
        });
      }
    },
    finishDNDHome: function (type) {
      if (type == 'newCall') {
        let data = this.$store.state.userModule.user;
        if (data.currentExtension) {
          this.isMainDND = data.currentExtension.isDND;
          this.dndTime = null;
          clearInterval(this.dndTimeInterval);
          this.dndTimeInterval = null;
        }
      } else {
        this.endDNDNote = '';
        this.endDNDNoteModal = false;
        this.$store.dispatch('getUserCurrent').then(() => {
          if (this.$store.state.userModule.successFlag) {
            let data = this.$store.state.userModule.user;
            if (data.currentExtension) {
              this.isMainDND = data.currentExtension.isDND;
              this.dndTime = null;
              clearInterval(this.dndTimeInterval);
              this.dndTimeInterval = null;
            }
          }
        });
      }
    },
    showDNDNoteModal: function (type) {
      this.endDNDType = type;
      this.endDNDNoteModal = true;
    },
    setFinishDND: function () {
      if (!this.endDNDNote || !this.endDNDNote.replace(/\s/g, '').length) {
        this.snackText = 'توضیحات نمی تواند خالی باشد';
        this.$refs.snackRef.snackModel = true;
        this.snackColor = '#FF5252';
        this.snakIcon = 'mdi-information';
        return;
      }
      this.disableUserDNDsnFunction(this.endDNDType, this.endDNDNote);
    },
    cancleDNDNoteModal: function () {
      this.endDNDType = '';
      this.endDNDNote = '';
      this.endDNDNoteModal = false;
    },
    stopPlayingAudioIn115RecentCalls: function () {
      if (this.$root.$refs.CallReport115) {
        console.log("");
        // console.log(this.$root.$refs.CallReport115?.stopMusic?.());
      }
    },
    fRinging: function ({ RingingModel }) {
      try {
        this.pauseMusicHome();
      } catch (error) {
        console.log('error pauseMusicHome: ', error);
      }
      if (!document.hidden) {
        this.callInformationModel = RingingModel;
        this.getAllRecentCallsFunction(this.callInformationModel.callerId);
        this.stopPlayingAudioIn115RecentCalls();
        if (this.newFormList?.length > 0) {
          const toastId = this.$toast.info('تماس جدید : ' + this.callInformationModel.callerId, {
            position: 'top-left',
            timeout: false,
            closeOnClick: true,
            showCloseButtonOnHover: false,
            pauseOnFocusLoss: false,
            pauseOnHover: false,
            draggable: false,
            hideProgressBar: true,
            closeButton: 'button',
            icon: true,
            // rtl: true,
          });
          let myObj = RingingModel ?? {};
          myObj['toastId'] = toastId;

          this.activeToastIds[this.callInformationModel.callerId] = myObj;
        } else {
          this.ringingModal = true;
        }
      }
    },
    fUp: function ({ upModel }) {
      try {
        this.pauseMusicHome();
      } catch (error) {
        console.log('error pauseMusicHome: ', error);
      }
      if (!document.hidden) {
        this.newFormList.push({
          newForm: true,
          uniqueId: upModel.uniqueId,
          callerId: upModel.callerId,
          destination: upModel.destination,
          newFormType: 'call',
        });
        this.showDialogNewform = true;
        this.ringingModal = false;
        if (this.newFormList?.length > 1) {
          this.newTabForm = upModel.uniqueId;
        }
        try {
          this.activeToastIds = [];
          this.$toast.clear();
        } catch (error) {
          console.log('error : ', error);
        }
      }
    },
    fHangUp: function ({ hangUpModel }) {
      if (this.ringingModal == true) {
        this.callInformationModel = hangUpModel;
        this.ringingModal = false;
        this.callInformationModel = null;
      }
      try {
        const toastId = this.activeToastIds?.[hangUpModel?.callerId]?.toastId;
        this.$toast.dismiss(toastId);
        delete this.activeToastIds?.[hangUpModel?.callerId];
      } catch (error) {
        console.log('error : ', error);
      }
    },
    setUniqueId: function (value = null) {
      this.uniqueId = value;
    },
    onAgentContactInDoctorModule: function ({ upModel }) {
      this.setUniqueId(), this.setUniqueId(upModel?.uniqueId);
    },
    onAgentContactInDispatchModule: function ({ upModel }) {
      this.setUniqueId(), this.setUniqueId(upModel?.uniqueId);
    },
    closeCallModal: function () {
      this.ringingModal = false;
    },
    onDoctorHangup: function () {
      const isDetailModalOpen = this.$root.$refs.DoctorMissions.orderModal;
      if (!isDetailModalOpen) this.setUniqueId();
      else return;
    },
    onDispatchHangup: function () {
      const isOrderModalModalOpen = this.$root.$refs.Mission800View.editModal;
      if (!isOrderModalModalOpen) this.setUniqueId();

      const isOrderModalModalOpenCurrent = this.$root.$refs.currentMission800View.editModal;
      if (!isOrderModalModalOpenCurrent) this.setUniqueId();
      else return;
    },
    onMenuItemClick: function (title, module) {
      if (!this.mini) this.goToItems(title, module);
    },
  },
  provide() {
    return {
      setUniqueId: this.setUniqueId,
    };
  },
  computed: {
    userNotificationsItems: function () {
      return [...this.$store.state?.UserNotifications800Module?.allUserNotifications];
    },
  },
  watch: {
    isNotificationBarOpen: function (isNotificationBarOpenValue) {
      if (isNotificationBarOpenValue) this.getAllUserNotificationsOnFirstLoad();
    },
  },
};
</script>

<style scoped>
>>>.container {
  padding-top: 0px !important;
}

>>>.myList .mdi-chevron-down::before {
  color: white !important;
}

.appbar-wrapper {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  padding: 0px 8px;
  /* position: relative;
  top: 5px;
  width: 100%; */
}

.appbar-left {
  display: flex;
  align-items: center;
  gap: 8px;
  flex: 0 0 auto;
}

.logo {
  flex-shrink: 0;
}

.time {
  font-size: 14px;
  font-weight: 500;
  color: #333;
  white-space: nowrap;
  position: relative;
  left: -39px;
}

.appbar-center {
  flex: 1;
  text-align: center;
}

.title-main {
  font-size: 44px;
  font-weight: 500;
  color: #1a237e;
  font-family: 'IranNastaliq' !important;
  line-height: 32px;
}

.title-sub {
  font-size: 26px;
  color: #424242;
  margin-right: 4px;
  font-family: 'IranNastaliq' !important;
}

.appbar-right {
  display: flex;
  align-items: center;
  gap: 8px;
  flex: 0 0 auto;
}

.extension {
  white-space: nowrap;
  box-shadow: 0px 0px 5px 1px #eaeaea;
}

@media (max-width: 768px) {
  .title-sub {
    display: none;
  }

  .logo {
    width: 20px !important;
    height: 20px !important;
  }
}

::v-deep .v-navigation-drawer__content::-webkit-scrollbar {
  width: 6px !important;
  height: 8px !important;
}

::v-deep .v-navigation-drawer__content::-webkit-scrollbar-track {
  background: var(--v-lightColor-lighten1) !important;
  border-radius: 10px !important;
}

::v-deep .v-navigation-drawer__content::-webkit-scrollbar-thumb {
  background: #bcbcbc !important;
  border-radius: 10px !important;
}

::v-deep .v-navigation-drawer__content::-webkit-scrollbar-thumb:hover {
  background: #ffffff !important;
}
</style>

<style scoped lang="scss">
.audioPlayerHome {
  // position: absolute;
  position: fixed;
  bottom: 10px;
  left: 10px;
  width: 400px;
  z-index: 2147483647;
  border-radius: 12px;
  border: 1px solid var(--dark-color);
  overflow: hidden;

  .audioPlayerHomeContent {
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 10px;
    padding: 8px 16px;
  }
}

.handelDilaogsNewcall {
  position: absolute;
  right: 101%;
}

////
.NewtabsCall {
  display: flex;
  gap: 4px;
  width: 100%;
  justify-content: flex-start;
  align-items: flex-end;

  .tab-wrapper {
    display: flex;
    flex-direction: column;
    gap: 0;
    justify-content: flex-start;
    align-items: flex-start;
  }

  .tab-new-label {
    width: 40px;
    color: white;
    font-size: 11px;
    background-color: #ff0000;
    padding: 0 8px;
    padding-top: 0;
    border-top-left-radius: 8px;
    border-top-right-radius: 8px;
    margin-right: 8px;
    text-align: center;
  }

  .tab-item {
    margin-top: auto;
    background-color: #c4c4c4;
    transition: all 0.3s ease;
    display: flex;
    gap: 8px;
    min-width: 110px;
    justify-content: flex-start;
    align-items: center;
    padding: 8px 16px;
    padding-top: 8px;
    cursor: pointer;
    border-top-left-radius: 12px;
    border-top-right-radius: 12px;
  }

  .tab-item.selectedTab {
    background-color: white !important;
  }

  .tab-item:hover {
    background-color: #3b82f6;
  }

  .nowrap-text {
    white-space: nowrap;
  }
}

.newCallContent {
  background: white;
  position: relative !important;
  overflow: hidden;
  border-top-left-radius: 16px;
}

.dndStyleMenu {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  gap: 15px;
  width: 100%;
  padding: 15px 10px;

  .itemTime {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    gap: 5px;
    width: 100%;

    .divid {
      flex: 1;
      border-bottom: 1px dashed #b8b8b86a;
    }
  }

  .btn {
    width: 80%;
    display: flex;
    justify-content: center;
    align-items: center;
    margin: auto;
  }
}

///

.notification-bar {
  overflow-y: hidden;
  z-index: 1001;

  &-header {
    margin: 1rem !important;

    &-title {
      color: black;
      font-size: 1rem;
      font-weight: 500;
    }

    &-seperator {
      margin-top: 12px;
      width: 100%;
      height: 2px;
      background: linear-gradient(90deg,
          rgba(148, 58, 45, 0) -12.77%,
          var(--v-darkColor-base) 51.82%,
          rgba(148, 58, 45, 0) 116.41%);
    }
  }
}

.appbar-title-content {
  font-family: 'IranNastaliq' !important;
  font-size: 20px;
  color: var(--text-light-color) !important;
}

.appbar-title-content2 {
  font-family: 'IranNastaliq' !important;
  font-size: 34px;
  color: var(--dark-color) !important;
}

.right-now-time {
  color: #717374;
  font-size: 13px;
  font-weight: 500;
}

.menu-username-content {
  font-family: 'Entezar';
  font-size: 22px;
  font-weight: 700;
}

.menu-items {
  color: white !important;
}

>>>.v-list-item__icon .theme--light.v-icon {
  color: white !important;
}

.expand-menu-icon {
  cursor: pointer;
}

.version-text {
  color: white !important;
  font-size: 12px;
  margin-right: 2px;
}

.version-text-open-menu {
  color: white !important;
  font-size: 12px;
  margin-right: 2px;
}

.user-no-img {
  margin-right: 3px !important;
}

.user-menu-img {
  border-radius: 50% !important;
}

.menu-bottom-divider {
  border-top: 1px white solid;
  border-bottom: none;
  border-right: none;
  border-left: none;
  width: 30px !important;
}

.menu-user-fullname {
  color: white !important;
  font-weight: 700;
  font-size: 14px;
  cursor: pointer !important;
}

.menu-user-role {
  color: white !important;
  font-weight: 400;
  font-size: 12px;
  cursor: pointer !important;
}

.menu-bottom-divider-open {
  border-top: 1px white solid;
  border-bottom: none;
  border-right: none;
  border-left: none;
  width: 100% !important;
}

.change-role-modal {
  background: var(--light-color) !important;
  border-top-right-radius: 0px !important;
  border-top-left-radius: 15px !important;
  border-bottom-right-radius: 0px !important;
  border-bottom-left-radius: 15px !important;
  overflow-y: auto;
}

.change-role-modal-menu {
  border-top-right-radius: 0px !important;
  border-top-left-radius: 15px !important;
  border-bottom-right-radius: 0px !important;
  border-bottom-left-radius: 15px !important;
}

.change-role-modal-title {
  color: white;
  font-weight: 600;
  font-size: 16px;
}

.change-role-modal-items-card {
  background: var(--light-color) !important;
  border: 2px solid white;
  border-radius: 10px !important;
}

.change-role-modal-items-card-text {
  color: white;
  font-weight: 400;
  font-size: 14px;
}

.extension-title {
  background: white !important;
  padding-left: 15px !important;
  padding-right: 15px !important;
  padding-top: 5px !important;
  padding-bottom: 5px !important;
  border-radius: 10px !important;
  color: var(--dark-color) !important;
  font-size: 14px !important;
}

.modal-header {
  border-bottom: 2px solid var(--modal-border-color);
  border-bottom-right-radius: 12px !important;
  border-bottom-left-radius: 12px !important;
}

.modal-title-text {
  color: white;
  font-weight: 500;
  font-size: 16px;
}

.modal-title-text2 {
  color: var(--dark-color);
  font-weight: 500;
  font-size: 16px;
}

.new-call-modal-number {
  background: var(--background-color) !important;
  padding-right: 60px !important;
  padding-left: 50px !important;
  padding-top: 1.7vh !important;
  border-top-right-radius: 35px !important;
  border-bottom-right-radius: 35px !important;
  height: 6.5vh !important;
  margin-top: 2.5vh !important;
  margin-left: -1vh !important;
  border-right: 2px solid var(--new-call-effect) !important;
}

.new-call-modal-number-text {
  color: #212121;
  font-size: 20px !important;
}

.recent-text {
  font-size: 14px;
  font-weight: 600;
  color: #212121;
}

.recent-date {
  font-size: 13px !important;
  color: #212121;
}

.recent-result {
  font-size: 13px !important;
  color: #212121;
  font-weight: 600;
  margin-top: 5px !important;
}

.new-call-card {
  border-radius: 100px !important;
}

>>>.new-call-dialog {
  border-radius: 50px !important;
}

.new-call-header {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 4px;
  width: 100%;
  background: var(--dark-color) !important;
  border-top-right-radius: 50px !important;
  border-top-left-radius: 50px !important;
}

.new-call-dialog-card-content {
  height: 45vh !important;
  overflow-y: auto;
}

.first-div-call {
  position: absolute;
  background: var(--dark-color) !important;
  height: 6vh !important;
  width: 6vh !important;
  border-radius: 50% !important;
  margin-top: 1vh !important;
  margin-right: 1vh !important;
}

.second-div-call {
  position: absolute;
  background: var(--light-color) !important;
  height: 8vh !important;
  width: 8vh !important;
  border-radius: 50% !important;
  margin-top: 1vh !important;
  margin-right: 1vh !important;
}

.thrid-div-call {
  position: absolute;
  background: var(--new-call-effect) !important;
  height: 10vh !important;
  width: 10vh !important;
  border-radius: 50% !important;
  margin-top: 1vh !important;
  margin-right: 1vh !important;
}

.forth-div-call {
  position: relative;
  background: var(--background-color) !important;
  height: 12vh !important;
  width: 12vh !important;
  border-radius: 50% !important;
}

.new-call-calling-icon-position {
  margin-top: 2vh !important;
  margin-right: 2vh !important;
}

.recent-call-new-call-dialog {
  &-container {
    width: 7.375rem !important;
  }

  &-card {
    border: 1px solid var(--light-color) !important;
    height: 7.375rem !important;
    width: 100% !important;
    border-radius: 50% !important;
    padding: 0.5rem;

    &-body {
      background-color: var(--background-color);
      border-radius: 50%;
      height: 100%;
    }
  }
}

.recent-call-new-call-dialog-inside {
  position: absolute;
  height: 14vh !important;
  border-radius: 50% !important;
  background: var(--background-color) !important;
  margin-right: 3vh !important;
  margin-top: 2.5vh !important;
}

.divider-new-call {
  height: 1vh !important;
  width: 10vh !important;
  color: white !important;
  border-top: 1vh solid white !important;
  border-bottom: none !important;
  border-left: none !important;
  border-right: none !important;
  border-radius: 10px !important;
}

.logo-location {
  padding-top: 2.25vh !important;
}

.drawer-design {
  z-index: 10000;
  overflow-y: hidden;
  position: fixed;
}

@media only screen and (min-width: 1200px) {
  .drawer-design {
    border-top-right-radius: 10px !important;
    border-top-left-radius: 10px !important;
    top: 50px !important;
    // top: 6.5vh !important;
    // height: 93.5vh !important;
    height: calc(100vh - 52px) !important;
    z-index: 9;
    box-shadow: 0 3px 5px -1px rgba(0, 0, 0, 0.2), 0 6px 10px 0 rgba(0, 0, 0, 0.14),
      0 1px 18px 0 rgba(0, 0, 0, 0.12) !important;
  }

  .site-main-content-position {
    padding-top: 50px !important;
    padding-right: 7.5vh !important;
    // padding-top: 3.5vh !important;
  }
}

@media only screen and (min-width: 1366px) {
  .drawer-design {
    border-top-right-radius: 10px !important;
    border-top-left-radius: 10px !important;
    // top: 6.5vh !important;
    top: 50px !important;
    z-index: 9;
    // height: 93.5vh !important;
    height: calc(100vh - 52px) !important;
    box-shadow: 0 3px 5px -1px rgba(0, 0, 0, 0.2), 0 6px 10px 0 rgba(0, 0, 0, 0.14),
      0 1px 18px 0 rgba(0, 0, 0, 0.12) !important;
  }

  .site-main-content-position {
    padding-top: 50px !important;
    padding-right: 7.5vh !important;
    // padding-top: 3.5vh !important;
  }
}

@media only screen and (min-width: 1536px) {
  .drawer-design {
    border-top-right-radius: 10px !important;
    border-top-left-radius: 10px !important;
    // top: 5.5vh !important;
    top: 50px !important;
    z-index: 9;
    // height: 94.5vh !important;
    height: calc(100vh - 52px) !important;
    box-shadow: 0 3px 5px -1px rgba(0, 0, 0, 0.2), 0 6px 10px 0 rgba(0, 0, 0, 0.14),
      0 1px 18px 0 rgba(0, 0, 0, 0.12) !important;
  }

  .site-main-content-position {
    padding-top: 50px !important;
    padding-right: 7vh !important;
    //padding-top: 3vh !important;
  }
}

.end-dnd-btn {
  text-decoration: line-through !important;
}
</style>
<style scoped>
>>>.moveOutsideRight {
  position: absolute !important;
  right: 101% !important;
}

>>>.border50 {
  border-radius: 50px !important;
}
</style>
